const ExportService = {
  exportToCsv(filename, columns, rows) {
    const getNestedValue = (obj, path) =>
      path ? path.split(".").reduce((acc, part) => (acc ? acc[part] : undefined), obj) : undefined;

    const headerRow = columns.map(c => `"${(c.text || "").replace(/"/g, '""')}"`).join(",");

    const dataRows = (rows || []).map(row =>
      columns
        .map(col => {
          let val =
            typeof col.format === "function" ? col.format(row) : col.value ? getNestedValue(row, col.value) : "";
          if (typeof val === "boolean") val = val ? "Yes" : "No";
          const clean = val === null || val === undefined ? "" : String(val);
          return `"${clean.replace(/"/g, '""')}"`;
        })
        .join(",")
    );

    const csvContent = "\uFEFF" + [headerRow, ...dataRows].join("\r\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const date = new Date().toISOString().slice(0, 10);
    link.download = `${filename}_${date}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }
};

export default ExportService;
